const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const current = new URL(location.href);
document.querySelectorAll('.wk-mobile-dock a').forEach(a => {
  const url = new URL(a.href);
  const active = url.pathname === current.pathname && url.searchParams.get('view') === current.searchParams.get('view');
  if (active) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
});

// Customer review rail: swipe, scroll or use the keyboard. No automatic animation.
for(const host of document.querySelectorAll('[data-wk-reviews]')){
 const rail=host.querySelector('.wk-review-rail'),toggle=host.querySelector('[data-review-pause]');
 if(toggle)toggle.hidden=true;
 if(rail){rail.tabIndex=0;rail.setAttribute('role','region');rail.setAttribute('aria-label','Customer reviews — scroll to read more');}
}

const offer = document.querySelector('[data-wk-offer]');
const offerDialog = document.querySelector('[data-wk-offer-dialog]');
if (offer && offerDialog) {
  const end = Date.parse(offer.dataset.end), start = Date.parse(offer.dataset.start), key = `wk-offer-seen:${start}`;
  let seen = false; try { seen = localStorage.getItem(key) === 'yes'; } catch { try { seen = sessionStorage.getItem(key) === 'yes'; } catch {} }
  function remember() { try { localStorage.setItem(key, 'yes'); } catch { try { sessionStorage.setItem(key, 'yes'); } catch {} } }
  function close() { offerDialog.close(); remember(); }
  offerDialog.querySelector('[data-close-offer]').addEventListener('click', close);
  offerDialog.addEventListener('cancel', remember);
  offerDialog.addEventListener('click', e => { if (e.target === offerDialog) { const r = offerDialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); } });
  const active = () => Date.now() >= start && Date.now() < end;
  function expire() { if (!active()) { offer.hidden = true; if (offerDialog.open) offerDialog.close(); } }
  expire();
  document.querySelectorAll('[data-offer-open]').forEach(button => button.addEventListener('click', () => { if (active() && !document.querySelector('dialog[open]')) offerDialog.showModal(); }));
  document.addEventListener('visibilitychange', expire); setTimeout(expire, Math.max(0, Math.min(2147483647, end - Date.now())));
}
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-copy-offer]'); if (!button) return;
  const code = button.dataset.copyOffer, status = document.querySelector('[data-copy-status]');
  try { await navigator.clipboard.writeText(code); const label = button.querySelector('[data-copy-label]'); if (label) label.textContent = label.dataset.copied; if (status) status.textContent = status.dataset.success; else button.textContent = code + ' ✓'; }
  catch { if (status) status.textContent = `Your code is ${code}. Select it and copy, or enter it at checkout.`; }
});

// Insert guidance next to the existing delivery app without replacing or modifying its fields.
function markDeliveryDate(context = document) {
  const fields = context.querySelectorAll?.('input[type="date"],input[id*="datepicker"],input[name*="delivery_date"],input[name*="shipping_date"],input[id*="delivery-date"],input[id*="shipping-date"]') || [];
  for (const input of fields) {
    if (!input.closest('.cart-page,.cart-drawer') || input.dataset.wkDateMarked) continue;
    const guide = document.querySelector('[data-wk-date-prompt]'); if (!guide) continue;
    input.dataset.wkDateMarked = 'true'; const host = input.closest('form')?.id === 'cart-form' ? input.parentElement : input.closest('.shopify-app-block') || input.parentElement;
    host.before(guide); guide.hidden = false;
  }
}
markDeliveryDate();
let dateQueued = false;
new MutationObserver(() => { if (dateQueued) return; dateQueued = true; requestAnimationFrame(() => { markDeliveryDate(); dateQueued = false; }); }).observe(document.body, { childList: true, subtree: true });
